import { Component } from '@angular/core';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ApiService } from 'app/api.service';
import { Pagination } from 'app/shared/pagination';

@Component({
	selector: 'modal-task-notes',
	templateUrl: './modal-task-notes.component.html'
})
export class ModalTaskNotesComponent extends UIModalBaseComponent {

	list = [];
	editNote = '';
	editing = null;
	pagination = new Pagination();

	constructor(
		public app: AppService,
		public api: ApiService
	) {
		super();
	}

	open(mdata: any) {
		this.list = mdata.list || [];
		this.editNote = '';
		this.editing = null;
		this.modal.open();
	}

	deleteNote(note) {
		this.app.dialog.pop('Delete Note', 'Are you sure you want to delete this note?', ['Cancel', '*Delete'], (button) => {
			if (button === 1) {
				this.api.activity.delete({ id: note.id }, () => {
					this.modal.close('deleted');
				}, error => {
					this.app.notifications.showDanger(error.message);
				});
			}
		});
	}

	editMode(i) {
		this.editNote = this.list[i].note;
		this.editing = i;
	}

	saveNote() {
		if (!this.editing === null) return;

		const a = this.list[this.editing];
		this.api.activity.update({
			id: a.id,
			note: this.editNote
		}, () => {
			this.list[this.editing].note = this.editNote;
			this.editing = null;
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

}
